import { useEffect, useState } from "react";
import { _EcmDocument, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { BasicPage } from "../theme/Component/BasicPage"
import { BasicButton } from "../theme/Component/BasicButton";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicSwitch } from "../theme/Component/BasicSwitch";

export const ProyeccionNomina = () => {

    const _ecm = useDataBean(_EcmDocument);
    const { instance, setBean, bean } = _ecm;
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [ver, setVer] = useState<boolean>(false);
    const [key, setkey] = useState<number>(_single.getRandomInt());
    const [listValue,setListValue] = useState<any>([]);
    const [listMonth,setListMonth] = useState<any>([]);

    useEffect(()=>{
        setkey(_single.getRandomInt())
    },[ver])

    const cargarProyeccion = () => {
        instance.getPayrollAnnualDataReport(year).then(
            (resp: any) => {
                console.log(resp);
                makeTable(resp);
                // setLista(resp);
            }
        )
    }

    const makeTable =(list:any[])=>{
        let temp:any = [];
        let temp1:any = [];
        list.forEach(element => {
            temp.push(
                {
                    DataBeanProperties:{
                        BudgetIDStr:element.DataBeanProperties.BudgetIDStr,
                        BudgetName:element.DataBeanProperties.BudgetName,
                        Enero:element.DataBeanProperties["0"]?.Value,
                        Febrero:element.DataBeanProperties["1"]?.Value,
                        Marzo:element.DataBeanProperties["2"]?.Value,
                        Abril:element.DataBeanProperties["3"]?.Value,
                        Mayo:element.DataBeanProperties["4"]?.Value,
                        Junio:element.DataBeanProperties["5"]?.Value,
                        Julio:element.DataBeanProperties["6"]?.Value,
                        Agosto:element.DataBeanProperties["7"]?.Value,
                        Septiembre:element.DataBeanProperties["8"]?.Value,
                        Octubre:element.DataBeanProperties["9"]?.Value,
                        Noviembre:element.DataBeanProperties["10"]?.Value,
                        Dicimebre:element.DataBeanProperties["11"]?.Value,
                    }
                }
            );
            temp1.push(
                {
                    DataBeanProperties:{
                        BudgetIDStr:element.DataBeanProperties.BudgetIDStr,
                        BudgetName:element.DataBeanProperties.BudgetName,
                        Enero:element.DataBeanProperties["0"]?.EmployeeCount,
                        Febrero:element.DataBeanProperties["1"]?.EmployeeCount,
                        Marzo:element.DataBeanProperties["2"]?.EmployeeCount,
                        Abril:element.DataBeanProperties["3"]?.EmployeeCount,
                        Mayo:element.DataBeanProperties["4"]?.EmployeeCount,
                        Junio:element.DataBeanProperties["5"]?.EmployeeCount,
                        Julio:element.DataBeanProperties["6"]?.EmployeeCount,
                        Agosto:element.DataBeanProperties["7"]?.EmployeeCount,
                        Septiembre:element.DataBeanProperties["8"]?.EmployeeCount,
                        Octubre:element.DataBeanProperties["9"]?.EmployeeCount,
                        Noviembre:element.DataBeanProperties["10"]?.EmployeeCount,
                        Diciembre:element.DataBeanProperties["11"]?.EmployeeCount,
                    }
                }
            );
        });
        setListValue(temp);
        setListMonth(temp1);
        
    }

    const head = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'BudgetName', visible: true },
        { title: 'Enero', property: 'Enero', visible: true,mask:MASK_MONEY },
        { title: 'Febrero', property: 'Febrero', visible: true,mask:MASK_MONEY },
        { title: 'Marzo', property: 'Marzo', visible: true,mask:MASK_MONEY },
        { title: 'Abril', property: 'Abril', visible: true,mask:MASK_MONEY },
        { title: 'Mayo', property: 'Mayo', visible: true,mask:MASK_MONEY },
        { title: 'Junio', property: 'Junio', visible: true,mask:MASK_MONEY },
        { title: 'Julio', property: 'Julio', visible: true ,mask:MASK_MONEY},
        { title: 'Agosto', property: 'Agosto', visible: true ,mask:MASK_MONEY},
        { title: 'Septiembre', property: 'Septiembre', visible: true ,mask:MASK_MONEY},
        { title: 'Octubre', property: 'Octubre', visible: true ,mask:MASK_MONEY},
        { title: 'Noviembre', property: 'Noviembre', visible: true ,mask:MASK_MONEY},
        { title: 'Diciembre', property: 'Diciembre', visible: true ,mask:MASK_MONEY},
    ]
    const head1 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'BudgetName', visible: true },
        { title: 'Enero', property: 'Enero', visible: true },
        { title: 'Febrero', property: 'Febrero', visible: true },
        { title: 'Marzo', property: 'Marzo', visible: true },
        { title: 'Abril', property: 'Abril', visible: true },
        { title: 'Mayo', property: 'Mayo', visible: true },
        { title: 'Junio', property: 'Junio', visible: true },
        { title: 'Julio', property: 'Julio', visible: true },
        { title: 'Agosto', property: 'Agosto', visible: true },
        { title: 'Septiembre', property: 'Septiembre', visible: true},
        { title: 'Octubre', property: 'Octubre', visible: true},
        { title: 'Noviembre', property: 'Noviembre', visible: true },
        { title: 'Diciembre', property: 'Diciembre', visible: true },
    ]


    return (
        <BasicPage titulo="Ejecución Nómina">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-3 mt-4" >
                    <BasicButton icon="" eventClick={cargarProyeccion}>Cargar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicSwitch estado={ver} eventChange={(e)=>{setVer(e)}} label="Ver Valores"/>
                </div>
                <div className="col-md-12">
                    <BasicTable customRows={25}  key={key} head={ver ? head :head1} body={ver ? listValue : listMonth} rowSet={setBean}></BasicTable>                   
                </div>
            </div>
        </BasicPage>
    )
}